/*
 * Copyright (c) 2018 Honeywell International Inc. All Rights Reserved.
 * Honeywell and its product names are among the trademarks and/or service marks owned by Honeywell International, Inc., or its subsidiaries.
 *
 * For patent information, see http://www.hsmpats.com.
 */

import React, { Component } from 'react';
import { Grid } from '@scuf/common';
import { DataTable } from '@scuf/datatable';
import { AppContext } from '@keystone/common';
import APIClient from '../../common/APIClient';

class historyDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      historyData: [],
      loading: false,
    };
  }

  async componentDidMount() {
    const { registerReloadFunction } = this.context;
    registerReloadFunction(this.getTableData);
    this.setState({ loading: true });
    await this.getTableData();
    this.setState({ loading: false });
  }

  componentWillUnmount() {
    const { unregisterReloadFunction } = this.context;
    unregisterReloadFunction();
  }

  getTableData = async () => {
    const { user, handleError } = this.context;
    try {
      let result = await APIClient.fetchHistory(user);
      result = result.response;
      // create userEmailId field at top level of object
      const historyData = result.map((item) => {
        const newItem = item;
        newItem.userEmailId = item.user.userEmailId;
        return newItem;
      });
      this.setState({ historyData });
    } catch (err) {
      handleError(err);
    }
  };

  render() {
    const { loading, historyData } = this.state;
    return (
      <div>
        <Grid>
          <Grid.Row>
            <Grid.Column width={12}>
              <h1>History</h1>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={12}>
              <DataTable
                data={historyData}
                loading={loading}
                resizableColumns
                columnResizeMode="fit"
                reorderableColumns
                scrollable
                scrollHeight="315%"
              >
                <DataTable.Column field="userEmailId" header="USER" sortable initialWidth="25%" />
                <DataTable.Column field="filePath" header="FILE" sortable initialWidth="55%" />
                <DataTable.Column
                  field="timeStamp"
                  header="TIME (GMT)"
                  sortable
                  initialWidth="20%"
                />
              </DataTable>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}

historyDetails.contextType = AppContext;

export default historyDetails;
